import template from './old-theme.html';
import themes from '../themes/themes';

export default {
	name: 'OldTheme',
	template,
	props: ['theme', 'data'],
	data () {
		return {
			themes
		};
	}
};
